"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoginConsoleState = /** @class */ (function () {
    function LoginConsoleState() {
        this.authenticated = false;
        this.cancelled = false;
        this.userDestinationPage = null;
        this.loggedInUserId = null;
        this.accountList = null;
        this.passcodeAccountList = null;
        this.selectedAccount = null;
        this.selectedMaskedBan = null;
        this.asmIndex = null;
        this.hasAccountSelection = false;
        this.isCMSCallCompleted = false;
        this.errorMessage = null;
        this.errorId = null;
    }
    return LoginConsoleState;
}());
exports.default = LoginConsoleState;
//# sourceMappingURL=LoginConsoleState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/LoginConsole/LoginConsoleState.js
// module id = 1482
// module chunks = 8